import React from "react";
import { useSelector } from "react-redux";
import { Card } from "antd";
import { DashboardLayout } from "../../layout";
import { ForumBox } from "./components";
import { RegisterModal, LoginModal, SuccessModal } from "../../components/Forms";
import { ForumsData } from "./mockData";

const Forums = () => {
  const { registerModal, loginModal, successModal } = useSelector(({ auth }) => auth);
  return (
    <DashboardLayout page="Allforums">
      <div className="mt-0 lg:mt-0">
        <Card style={{padding: 20, borderRadius: 20}}>
          {ForumsData.map((item, index) => (
            <ForumBox key={index} />
          ))}
         
        </Card>
      </div>
      <RegisterModal show={registerModal} />
      <LoginModal show={loginModal} />
      <SuccessModal show={successModal} />
    </DashboardLayout>
  );
};

export default Forums;
